import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";
import Colors from "../../Constants/Colors";

export default function SubscriberSearchDropdown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  placeholder = "Search or select...",
  marginLeft,
  marginTop,
  isDisabled = false,
  style,
  className,
  onSearchInputChange,
}) {
  const [isActive, setIsActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const selectedLabel =
    options.find((o) => String(o.id) === String(selected))?.label || "";

  // Clear search when selection changes
  useEffect(() => {
    setSearchTerm("");
  }, [selected]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Server-side: just show options as-is; client-side: filter locally
  const filteredOptions = onSearchInputChange
    ? options
    : searchTerm
    ? options.filter((o) =>
        (o.label || "").toLowerCase().includes(searchTerm.toLowerCase())
      )
    : options;

  const handleClick = (option) => {
    if (isDisabled) return;
    setSelected(option.id);
    setIsActive(false);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (!isActive) setIsActive(true);
    if (onSearchInputChange) {
      onSearchInputChange(value); // triggers API call in parent
    }
  };

  const handleInputFocus = () => {
    if (!isDisabled) setIsActive(true);
  };

  const handleInputClick = () => {
    if (!isDisabled) setIsActive(true);
  };

  return (
    <div
      className={`dropdown-CB ${className || ""}`}
      style={{
        width,
        marginLeft,
        marginTop,
        pointerEvents: isDisabled ? "none" : "auto",
        opacity: isDisabled ? 0.7 : 1,
        ...style,
      }}
      ref={dropdownRef}
    >
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label>

      <div style={{ position: "relative", marginTop: "6px" }}>
        <input
          type="text"
          placeholder={placeholder}
          value={isActive ? searchTerm : selectedLabel}
          onChange={handleSearchChange}
          onFocus={handleInputFocus}
          onClick={handleInputClick}
          disabled={isDisabled}
          style={{
            width: "100%",
            padding: "8px",
            border: "1px solid gray",
            fontSize: "14px",
            outline: "none",
            boxSizing: "border-box",
            cursor: isDisabled ? "not-allowed" : "text",
            backgroundColor: isDisabled ? "transparent" : Colors.color14,
            color: "rgb(106, 106, 106)",
          }}
        />
        <img
          src={DropDownIcon}
          alt="dropdown-icon"
          style={{
            position: "absolute",
            right: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            width: "31px",
            height: "22px",
          }}
        />
      </div>

      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{
            width: customWidth || "100%",
            top: customTop || "100%",
            marginTop: "4px",
            maxHeight: "300px",
          }}
        >
          <div style={{ maxHeight: "260px", overflowY: "auto" }}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div
                  key={option.id}
                  className="dropdown-item-CBV2"
                  onClick={() => handleClick(option)}
                  style={{
                    padding: "12px",
                    cursor: "pointer",
                  }}
                >
                  {option.label}
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "14px",
                }}
              >
                No results found
              </div>
            )}
          </div>

          {searchTerm && (
            <div
              style={{
                padding: "5px 10px",
                textAlign: "center",
                fontSize: "11px",
                color: "#666",
                backgroundColor: "#f9f9f9",
                borderTop: "1px solid #e0e0e0",
              }}
            >
              {filteredOptions.length} result
              {filteredOptions.length !== 1 ? "s" : ""} found
            </div>
          )}
        </div>
      )}
    </div>
  );
}